import { NgClass, NgTemplateOutlet } from '@angular/common'
import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core'
import { LessonTileStudyComponent } from '../../../lesson/tile/study/study.component'
import { DrawerState } from '../../drawer.component'
import { DrawerContentState } from '../../drawer'
import { BehaviorSubject } from 'rxjs'
import {
  DateOnly,
  distantPast,
  isSameContentOrder,
  log,
  resolveProperty
} from '@nx-superprep/utils'

import {
  ResponsiveComponent,
  SwipeItemListComponent
} from '@nx-superprep/shared'
import { HammerModule } from '@angular/platform-browser'

import { LessonTile } from '@nx-superprep/study'
import { MatIconModule } from '@angular/material/icon'
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu'

@Component({
  selector: 'pop-ui-lessons-list',
  standalone: true,
  templateUrl: './lessons-list.component.html',
  styleUrls: ['./lessons-list.component.scss'],
  imports: [
    NgClass,
    NgTemplateOutlet,
    HammerModule,
    LessonTileStudyComponent,
    SwipeItemListComponent,
    MatIconModule,
    TourMatMenuModule,
],
})
export class LessonsListComponent extends ResponsiveComponent {
  selected: LessonTile | undefined = undefined

  private _state?: DrawerState
  @Input()
  get state() {
    return this._state
  }
  set state(value) {
    const didChange = !this.isEqual(this._state?.contentState, value?.contentState)
    this._state = value
    if (didChange) {
      this.tiles.next((this.state?.contentState.tiles ?? []) as LessonTile[])
    }
    if (this._state?.contentState.selected) {
      //this.selected = this._state.contentState.selected
      this.selected = this.tiles.value.find((v) => v.selected)
      this.stateChange.emit(this._state)
    }
  }
  @Output() stateChange = new EventEmitter<DrawerState>()

  @Input() separator = true

  disabledTemplate = null

  tiles = new BehaviorSubject<LessonTile[]>([])

  get tileSource() {
    switch (this.state?.headerState.activeTab?.toLowerCase()) {
      case 'active':
        return this.tiles.value.filter((t) => !resolveProperty(t.finished))
      case 'done':
        return this.tiles.value.filter((t) => resolveProperty(t.finished))
      default:
        return this.tiles.value
    }
  }

  get isSwipeList() { return this.state?.type === 'dayplan-lessons' && !!this.state?.contentState.date }

  isEqual(
    a: DrawerContentState | undefined,
    b: DrawerContentState | undefined
  ) {
    return (
      a &&
      b &&
      a.date?.isSame(b.date ?? new DateOnly(distantPast)) &&
      isSameContentOrder((a.tiles ?? []) as LessonTile[], (b.tiles ?? []) as LessonTile[], [
        'id', 'progress', 'isAssigned', 'estimated', 'expectedStudyDate'
      ])
    )
  }

  isSelected(tile: LessonTile) {
    return this.isWeb && this.selected?.id === tile.id
  }

  onAction(event: Event) {
    log.debug(`event:`, event)
    const e = event as unknown as {
      action: string | (() => void)
      value: string | undefined
    }
    const action = e.action
    if (action === 'del') {
      const tile = this.tileFor(e.value)
      this.tiles.next(
        (this.state?.contentState.tiles ?? []).filter(
          (t) => t.id !== tile.id
        ) as LessonTile[]
      )
      if (typeof tile.action === 'function') {
        tile.action(action)
      }
    }
  }

  onSelect(e: unknown) {
    log.debug('select', e)
  }

  onSwipe(e: unknown) {
    log.debug('swipe', e)
  }

  listItemSwipeLeft(e: unknown) {
    log.debug('swipe left', e)
  }
  listItemSwipeRight(e: unknown) {
    log.debug('swipe right', e)
  }

  tileFor(id: string | undefined) {
    return this.tiles.value.find((t) => t.id === id) ?? this.tiles.value[0]
  }

  inside(tile: LessonTile) {
    return {
      id: tile.id,
      title: tile.title,
      subTitle: tile.description ?? '',
      mark: false
    }
  }

  get isOnboarding() {
    return this.state?.type === 'onboarding-lessons'
  }

  get isLoaded() {
    return this.tiles.value.length > 0
  }

  constructor() {
    super()
    super.rootClassName = 'lessons-list-root-class-name'
  }
}
